import React from 'react';
import PropTypes from 'prop-types';
import { DialogActions, Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { LoadingButton } from '~/modules/common/components';

const SetResourceAllocationDialogFooter = ({ onClose }) => {
  return (
    <DialogActions>
      <Button
        data-qe-id="SetResourceAllocationDialog_CancelButton"
        onClick={onClose}
        variant="contained"
      >
        <FormattedMessage id="setResourceAllocationDialog.cancel" />
      </Button>
      <LoadingButton
        color="primary"
        data-qe-id="SetResourceAllocationDialog_SubmitButton"
        isLoading={false} // TODO: implement loading state
        onClick={() => {}} // TODO: onClick handler to be implemented
        variant="contained"
      >
        <FormattedMessage id="setResourceAllocationDialog.setResourceAllocation" />
      </LoadingButton>
    </DialogActions>
  );
};

SetResourceAllocationDialogFooter.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default SetResourceAllocationDialogFooter;
